<template>
  <v-container fluid class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <h1 class="text-h5 font-weight-bold text-grey-darken-4">Leads (Pré-lançamento)</h1>
    </div>

    <v-card class="elevation-4">
      <v-card-text>
        <v-row class="mb-6" dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="searchTerm"
              placeholder="Pesquisar por nome, e-mail ou origem"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              @input="onFiltersChange"
            />
          </v-col>
        </v-row>

        <v-data-table-server
          :headers="columns"
          :items="leads"
          :items-length="totalItems"
          :loading="isLoading"
          :items-per-page="itemsPerPage"
          :page="page"
          :no-data-text="noDataMessage"
          class="elevation-0"
          @update:page="page = $event"
          @update:items-per-page="itemsPerPage = $event"
        >
          <template v-slot:item.created_at="{ item }">
            <span>{{ formatDateTime(item.created_at) }}</span>
          </template>
        </v-data-table-server>

        <v-alert v-if="hasError && !isLoading" type="error" variant="tonal" class="mt-4 text-center">
          Ocorreu um erro ao carregar os dados dos leads.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import api from '@/services/api'
import { useToastStore } from '@/store/toast'
import { useLoadingStore } from '@/store/loadingStore'
import dayjs from 'dayjs'

const toastStore = useToastStore()
const loadingStore = useLoadingStore()

const leads = ref([])
const isLoading = ref(true)
const hasError = ref(false)
const searchTerm = ref('')

const page = ref(1)
const itemsPerPage = ref(10)
const totalItems = ref(0)

const noDataMessage = computed(() => {
  if (isLoading.value) return 'Carregando...'
  return 'Nenhum lead encontrado.'
})

const columns = [
  { title: 'ID', key: 'id', sortable: true },
  { title: 'Nome', key: 'name', sortable: true },
  { title: 'E-mail', key: 'email', sortable: true },
  { title: 'Origem', key: 'source', sortable: true },
  { title: 'Criado em', key: 'created_at', sortable: true },
]

const loadLeads = async () => {
  isLoading.value = true
  hasError.value = false
  loadingStore.show()
  try {
    const params = {
      page: page.value,
      per_page: itemsPerPage.value,
      search: searchTerm.value,
    }

    const response = await api.get('/lead-captures', { params })

    leads.value = response.data.data
    totalItems.value = response.data.total
    itemsPerPage.value = response.data.per_page
    page.value = response.data.current_page
  } catch (error) {
    console.error('Erro ao carregar leads:', error)
    hasError.value = true
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao carregar a lista de leads.',
      color: 'error',
    })
  } finally {
    isLoading.value = false
    loadingStore.hide()
  }
}

watch([page, itemsPerPage], () => {
  loadLeads()
})

const onFiltersChange = () => {
  page.value = 1
  loadLeads()
}

function formatDateTime(dateTime) {
  if (!dateTime) return 'N/A'
  return dayjs(dateTime).format('DD/MM/YYYY HH:mm')
}

onMounted(() => {
  loadLeads()
})
</script>

<style scoped></style>

